const ARRAY_SEPARATOR = ',';

export function getCommaSeparatedParam(param?: string): string[] {
    const trimmedParam = param?.trim();
    return trimmedParam ? trimmedParam.split(ARRAY_SEPARATOR) : [];
}
